export default function () {
    const links = document.querySelectorAll('.menu-item a');
    let headerHeight;

    updateActiveClass();

    function addActiveClass(hash) {
        links.forEach(function (link) {
            if (link.hash === hash) {
                link.classList.add('current-section');
            } else {
                link.classList.remove('current-section');
            }
        });
    }

    function updateActiveClass(event) {
        const windowHash = window.location.hash;
        addActiveClass(windowHash);
    }

    function scrollToSection(targetElement, offset) {
        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top;
            let offsetPosition = 0;
            if (window.innerWidth <= 992) {
                offsetPosition = elementPosition - offset;
            }
            else{
                offsetPosition = elementPosition - offset;
            }

            window.scrollBy({
                top: offsetPosition,
                behavior: 'smooth'
            });

            history.pushState(null, null, `#${targetElement.id}`);
            updateActiveClass();
        }
    }

    window.addEventListener('hashchange', updateActiveClass);

    function initAfterLoad() {
        const initialHash = window.location.hash;
        const targetElement = document.getElementById(initialHash.substring(1));

        const section = document.querySelector('.about');
        const style = window.getComputedStyle(section);
        const menu = document.querySelector('.header__home-menu');
        const header = document.querySelector('.header');
        const menuHeight = menu.offsetHeight;
        headerHeight = header.offsetHeight;

        const paddingTop = 2;

        console.log('init');

        if (window.innerWidth <= 992) {
            scrollToSection(targetElement,  headerHeight);
        } else {
            scrollToSection(targetElement, headerHeight);
        }
    }

    window.addEventListener('load', function (){
        setTimeout(initAfterLoad, 100);
    });

    setTimeout(function () {
        updateActiveClass();
    }, 1000);

    links.forEach(function (link) {
        link.addEventListener('click', function (event) {
            if (document.body.classList.contains('page-id-78') || document.body.classList.contains('page-id-17')) {
                event.preventDefault();
                const targetParent = event.target.parentNode;
                const targetLink = event.target;
                const clickedHash = link.hash;
                if (targetParent.classList.contains('lang-item')) {
                    window.location.href = targetLink.getAttribute('href');
                } else {
                    const targetSection = clickedHash.substring(1);
                    updateActiveClass();
                    const targetElement = document.getElementById(targetSection);

                    // if (window.innerWidth < 992) {
                    //     const menu = document.querySelector('.header__home-menu');
                    //     const menuHeight = menu.offsetHeight;
                    //     const offSet = menuHeight + headerHeight;
                    //
                    //     scrollToSection(targetElement, offSet);
                    // } else {
                        scrollToSection(targetElement, headerHeight);
                    // }

                }
            }
        });
    })

    /**
     * Updates the margin top of the about container based on the screen width.
     *
     * @return {undefined}
     */
    function updateAboutContainerMarginTop() {
        const screenWidth = window.innerWidth;

        const aboutContainer = document.querySelector('.about__container');
        if (!aboutContainer) {
            return;
        }

        const headerMenuHeight = document.querySelector('.header__home-menu').offsetHeight;
        const headerNavHeight = document.querySelector('.header__home-nav').offsetHeight;
        const headerHeight = document.querySelector('.header').offsetHeight;

        const totalHeaderHeight = headerMenuHeight + headerHeight;

        if (screenWidth <= 992) {
            // aboutContainer.style.marginTop = (totalHeaderHeight - 12) + 'px';
            aboutContainer.style.marginTop = (headerHeight) + 'px';
        } else {
            aboutContainer.style.marginTop = (headerHeight) + 'px';
        }

    }

    window.addEventListener('resize', updateAboutContainerMarginTop);
    window.addEventListener('load', updateAboutContainerMarginTop);


    function findLongestAnchorText() {

        const screenWidth = window.innerWidth;
        const navigation = document.querySelector('nav.header__home-nav');
        const about = document.querySelector('.about');

        if (!navigation) {
            // console.log('Element <nav> з класом "header__home-nav" не знайдено.');
            return;
        }

        const anchors = navigation.querySelectorAll('a');

        let maxLength = 0;

        anchors.forEach(anchor => {
            const length = anchor.offsetWidth;
            if (length > maxLength) {
                maxLength = length;
            }
        });

        if (screenWidth <= 992) {
            about.style.paddingLeft = (maxLength+20) + 'px';
        }
        else {
            about.style.paddingLeft = 0 + 'px';
        }
    }

    window.addEventListener('load', findLongestAnchorText);
    window.addEventListener('resize', findLongestAnchorText);

}